<!-- eslint-disable vue/max-attributes-per-line -->
<template>
  <!-- 字典 -->
  <a-row :gutter="24">
    <a-col :span="12">
      <a-card :bordered="false">
        <div class="table-page-search-wrapper">
          <a-form layout="inline">
            <a-row :gutter="48">
              <a-col :md="14" :sm="24">
                <a-col :md="35" :sm="24" v-if="this.$store.state.user.info.systemAdmin">
                  <a-form-item label="水司">
                    <a-select placeholder="请选择" default-value v-model="query.tenantId" allow-clear>
                      <a-select-option value>全部</a-select-option>
                      <a-select-option v-for="item in tenantList" :key="item.tenantId" :value="item.tenantId">{{
                        item.tenantName }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <span class="table-page-search-submitButtons">
                  <!-- <a-button type="primary" @click="queryList">查询</a-button>
                  <a-button style="margin-left: 8px">重置</a-button>-->
                  <a-button type="primary" @click="queryList">查询</a-button>
                  <a-button type="primary" style="margin-left: 8px" @click="addOrUpdateHandle()"
                    v-action:add>新增</a-button>
                  <a-button type="danger" style="margin-left: 8px" @click="deleteSelectRow()" v-action:del>删除</a-button>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <a-table :pagination="false" rowKey="id"
          :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
          :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)" :data-source="list"
          :columns="columns" :loading="dataListLoading">
          <span slot="parent" slot-scope="text, record">{{ record.parentName || '一级片区' }}</span>
          <span slot="action" slot-scope="text, record">
            <a @click="addOrUpdateHandle(record.id)" v-action:edit>编辑</a>
            <!--            <a-divider type="vertical" />-->
            <!--            <a-upload name="file" :multiple="false" :file-list="fileList" :customRequest="customRequest">-->
            <!--              <a @click="changeFile(record.id)" v-action:import>导入关联点</a>-->
            <!--            </a-upload>-->
          </span>
          <span slot="zoneAction" slot-scope="text,record">
            <span v-if="text != '一级分区'">{{ numberParseChina(record.level) }}级分区 — {{ text }}</span>
            <span v-else>{{ text }}</span>
          </span>
        </a-table>
        <a-modal title="操作" style="top: 20px" :width="800" destroyOnClose v-model="addOrUpdateVisible" @ok="handleOk"
          @cancel="handleCancel">
          <a-form-model class="tenant-form" :model="addOrUpdateForm" ref="addOrUpdateForm" :rules="rules">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="上级片区" prop="pid">
              <a-tree-select :tree-data="treeData" v-model="addOrUpdateForm.pid" style="width: 100%"
                :replace-fields="{ title: 'zoneName', key: 'id', value: 'id', selectable: 'selectable' }"
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" placeholder="请选择上级片区" allow-clear
                tree-default-expand-all></a-tree-select>
            </a-form-model-item>
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="片区名称" hasFeedback prop="zoneName">
              <a-input placeholder="请输入片区名称" v-model="addOrUpdateForm.zoneName" />
            </a-form-model-item>

            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="片区编号" prop="zoneCode">
              <a-input placeholder="请输入片区编号" v-model="addOrUpdateForm.zoneCode" />
            </a-form-model-item>

            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="售水量" prop="sellWater">
              <a-input placeholder="请输入售水量" v-model="addOrUpdateForm.sellWater" />
            </a-form-model-item>
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="漏损率" prop="leakageRate">
              <a-input-number style="width:100%" placeholder="请输入漏损率" v-model="addOrUpdateForm.leakageRate" />
            </a-form-model-item>
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="大屏步长" prop="leakageRate">
              <a-input-number style="width:100%" placeholder="请输入大屏步长" v-model="addOrUpdateForm.stepLength" />
            </a-form-model-item>

            <!--            <a-form-model-item v-if="isUpdate" :labelCol="labelCol" :wrapperCol="wrapperCol" label="关联点数据">-->
            <!--              <a-table-->
            <!--                size="middle"-->
            <!--                rowKey="id"-->
            <!--                :data-source="pipNetWorkList"-->
            <!--                :columns="columns2"-->
            <!--                :pagination="pagination2"-->
            <!--                @change="pageChange"-->
            <!--                :scroll="{ y: 300 }"-->
            <!--              ></a-table>-->
            <!--            </a-form-model-item>-->
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="地图选点" prop="geoJson">
              <!-- <div style="height:300px;">
            <collection-map
              :type="addOrUpdateForm.zoneType"
              :geo="addOrUpdateForm.geoJson"
              @data="addOrUpdateForm.geoJson = $event"
            />
              </div>-->
              <a-button type="default" @click="mapVisible = true">展开地图</a-button>
            </a-form-model-item>
          </a-form-model>
        </a-modal>
        <a-modal v-model="mapVisible" title="地图选点" width="100%" :mask="false"
          :dialogStyle="{ top: 0, margin: 0, padding: 0 }" destroyOnClose @ok="
            $refs.map.getGeomeryData()
          mapVisible = false
            ">
          <div style="height: calc(100vh - 156px)">
            <collection-map ref="map" :zone-id="addOrUpdateForm.id" :type="addOrUpdateForm.zoneType"
              :geo="addOrUpdateForm.geoJson" @data="addOrUpdateForm.geoJson = $event" />
          </div>
        </a-modal>
      </a-card>
    </a-col>
    <a-col :span="12">
      <a-card :bordered="false">
        <mind :g_data="gData" />
      </a-card>
    </a-col>
  </a-row>
</template>
<script>
import mixinViewModule from '@/mixin/commonModel'
import CollectionMap from '@/components/map/CollectionMap.vue'
import mind from '../partition/management/component/mind.vue'
const columns = [
  {
    title: '分区名称',
    dataIndex: 'zoneName',
    scopedSlots: { customRender: 'zoneAction' }
  },
  {
    title: '片区编号',
    dataIndex: 'zoneCode'
  },
  // {
  //   title: '上级分区',
  //   dataIndex: 'parentName',
  //   scopedSlots: { customRender: 'parent' }
  // },
  {
    title: '级别',
    dataIndex: 'level'
  },
  {
    title: '售水量',
    dataIndex: 'sellWater'
  },
  {
    title: '操作',
    width: '150px',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' }
  }
]
const columns2 = [
  {
    title: '关联点号',
    dataIndex: 'connectionPointNumber'
  },
  {
    title: '关联点名称',
    dataIndex: 'featurePoint'
  }
]
const list = []
function transTree (list) {
  return list.map((v) => {
    return { id: v.id, zoneName: v.zoneName, children: v.children ? transTree(v.children) : [] }
  })
}
export default {
  components: { CollectionMap, mind },
  mixins: [mixinViewModule],
  name: 'ManagementList',
  data () {
    return {
      selectId: '',
      columns2,
      pipNetWorkList: [],
      stabilizePipNetWorkList: [],
      pagination2: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: (total) => `共 ${total} 条记录`,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100']
      },
      dataListLoading: false,
      id: '',
      fileList: [],
      tenantList: [],
      query: {
        tenantId: this.$store.state.user.info.tenantId
      },
      queryUrl: 'zone-metering/zone-metering/tree',
      addOrUpdateUrl: 'zone-metering/zone-metering',
      queryOneUrl: 'zone-metering/zone-metering',
      deleteUrl: 'zone-metering/zone-metering',
      needPage: false,
      columns,
      geo: '{}',
      mapVisible: false,
      addOrUpdateForm: {
        id: '',
        zoneId: '',
        pid: '0',
        zoneName: '',
        zoneCode: '',
        zoneType: 2,
        geoJson: '{}',
        level: 0,
        sellWater: '',
        leakageRate: '',
        customColor: ''
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      }
    }
  },
  created () {
    this.getAllTenant()
  },
  computed: {
    treeData () {
      return [
        {
          id: '0',
          zoneName: '一级片区',
          children: this.filterTree(this.list, this.currentId)
        }
      ]
    },
    gData () {
      return transTree(this.list)
    },
    rules () {
      return {
        level: [{ required: true, pattern: /^[0-9]+\.?[0-9]*$/, message: '请输入数字' }],
        pid: [{ required: true, message: '请选择上级片区' }],
        zoneName: [{ required: true, message: '请输入片区名称' }],
        zoneType: [{ required: true, message: '请选择区域类型' }],
        sellWater: [{ pattern: /^[0-9]+\.?[0-9]*$/, message: '请输入正整数或正小数' }],
        leakageRate: [{ pattern: /^[0-9]+\.?[0-9]*$/, message: '请输入正整数或正小数' }],
        geoJson: []
      }
    }
  },
  methods: {
    numberParseChina (money) {
      // 汉字的数字
      var index = parseFloat(money)
      var cnNums = new Array('零', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十')
      return cnNums[money]
    },
    getAllTenant () {
      if (this.$store.state.user.info.systemAdmin) {
        this.$http
          .get('/manager/tenants/all')
          .then(({ data }) => {
            this.tenantList = data
          })
          .catch(({ e }) => {
            console.log(e)
          })
      }
    },
    // pageChange (pagination, filters, sorter) {
    //   this.pagination2.current = pagination.current
    //   this.pagination2.pageSize = pagination.pageSize
    //   this.getNetWorkList(this.selectId)
    // },
    // getNetWorkList (val) {
    //   const params = {
    //     zoneId: val,
    //     page: this.pagination2.current,
    //     limit: this.pagination2.pageSize
    //   }
    //
    //   this.$http
    //     .get('/pipe-network/pipes/page', { params })
    //     .then(({ data }) => {
    //       this.pagination2.total = data.total ? parseInt(data.total) : 0
    //       this.pipNetWorkList = data.list
    //       this.stabilizePipNetWorkList = data.list
    //     })
    //     .catch(() => {})
    // },
    addOrUpdateHandle (id) {
      ; (this.addOrUpdateForm = {
        id: '',
        zoneId: '',
        pid: '',
        zoneName: '',
        zoneType: 2,
        geoJson: '',
        level: '',
        sellWater: '',
        stepLength: ''
      }),
        (this.pipNetWorkList = [])
        ; (this.pagination2 = {
          current: 1,
          pageSize: 10,
          total: 0,
          showTotal: (total) => `共 ${total} 条记录`,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '50', '100']
        }),
          (this.isUpdate = false)
      this.currentId = id
      // this.$refs.addOrUpdateForm.resetFields()
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        console.log(this.$refs.addOrUpdateForm)
        this.$refs.addOrUpdateForm.resetFields()
        if (id) {
          this.isUpdate = true
          this.$http
            .get(`${this.queryOneUrl}/${this.currentId}`)
            .then(({ data }) => {
              this.addOrUpdateForm = { ...this._updateForm(this.addOrUpdateForm, data) }
              this.selectId = data.id
              // this.getNetWorkList(data.id)
              // this.stabilizePipNetWorkList = data.pipNetWorkList
            })
            .catch(() => { })
        }
      })
    },
    changeFile (id) {
      console.log(id)
      this.id = id
    },
    customRequest (data) {
      // 上传提交
      const formData = new FormData()
      formData.append('file', data.file)
      this.saveFile(formData)
    },
    saveFile (formData) {
      this.dataListLoading = true
      this.axios({
        method: 'post',
        url: '/zone-metering/zone-metering/upload-point',
        headers: {},
        params: {
          id: this.id
        },
        data: formData
      })
        .then((response) => {
          if (response.code === 0) {
            this.queryList()
            this.$message.success(response.message)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
        .finally(() => {
          this.dataListLoading = false
        })
    },
    filterTree (list, id) {
      if (id && list) {
        let realList = []
        realList = list.map((l) => {
          return {
            ...l,
            selectable: l.id != id,
            children: l.id == id ? this.filterTreetoSelected(l.children) : this.filterTree(l.children, id)
          }
        })
        return realList
      } else {
        return list
      }
    },
    filterTreetoSelected (list) {
      if (list) {
        return list.map((l) => ({ ...l, selectable: false, children: this.filterTreetoSelected(l.children) }))
      } else {
        return list
      }
    },
    setGeo (geoString) {
      console.log(geoString)
      // console.log(this.addOrUpdateForm.getFieldValue('geoJson'));
      this.addOrUpdateForm.setfi
    },
    handleOk (e) {
      e.preventDefault()

      this.$refs.addOrUpdateForm.validate((valid) => {
        if (valid) {
          const params = { id: this.currentId, ...this.addOrUpdateForm }
          console.log(params)
          this.$http[!this.currentId ? 'post' : 'put'](this.addOrUpdateUrl, params)
            .then((res) => {
              if (res.code === 0) {
                this.addOrUpdateVisible = false
                this.queryList()
                this.$refs.addOrUpdateForm.resetFields()
                return this.$message.success(res.message)
              }
            })
            .catch(() => { })
        }
      })
    }
  },
  watch: {}
}
</script>
<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
</style>
